import React, { useId, useRef } from "react";
import { Camera } from "lucide-react";
import { ClipLoader } from "react-spinners";
import "./CircleButton.scss";
import "./PillButton.scss";

interface CameraButtonProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
  // with a label, renders as one filled pill (icon + text, all tappable) —
  // the page's primary action; without, the plain circle icon
  children?: React.ReactNode;
}

const CameraButton: React.FC<CameraButtonProps> = ({
  onChange,
  loading,
  children,
}) => {
  const id = useId();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  if (loading) {
    return <ClipLoader size={16} />;
  }

  return (
    <>
      {/* a <label> for the hidden file input: tapping anywhere on it opens the
          camera / photo picker. Made focusable + Enter/Space-activated since a
          label isn't a keyboard target on its own. */}
      <label
        htmlFor={id}
        className={children ? "pill-button" : "circle-button camera-button"}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            fileInputRef.current?.click();
          }
        }}
      >
        <Camera size={20} />
        {children}
      </label>
      <input
        id={id}
        type="file"
        ref={fileInputRef}
        onChange={handleChange}
        accept="image/*"
        style={{ display: "none" }}
      />
    </>
  );
};

export default CameraButton;
